import * as React from "react";
export function SvgSpacesMediumExtractCertified(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      id="Spaces_Medium_Extract_Certified_svg__Layer_1"
      x={0}
      y={0}
      width={24}
      height={24}
      xmlSpace="preserve"
      {...props}
    >
      <style>{".Spaces_Medium_Extract_Certified_svg__st0{fill:#666766}"}</style>
      <path
        className="Spaces_Medium_Extract_Certified_svg__st0"
        d="M8 16c-2.6 0-4-.9-4-1.3V7c.9.6 2.3 1 4 1V7c-2.4 0-4-.9-4-1.5S5.6 4 8 4c1.8 0 3.1.5 3.7 1h1.2c-.4-1.2-2.4-2-4.9-2-2.8 0-5 1.1-5 2.5v9.2C3 16 5.2 17 8 17v-1z"
      />
      <path
        className="Spaces_Medium_Extract_Certified_svg__st0"
        d="M10 10c.9.6 2.3 1 4 1 1.7 0 3.1-.4 4-1v3h1V8.5C19 7.1 16.8 6 14 6S9 7.1 9 8.5V13h1v-3zm4-3c2.4 0 4 .9 4 1.5S16.4 10 14 10s-4-.9-4-1.5S11.6 7 14 7zM12 18.8c-1.3-.3-2-.8-2-1.1V16H9v1.7c0 1 1.2 1.8 3 2.1v-1z"
      />
      <circle
        id="Spaces_Medium_Extract_Certified_svg__CircleBlue_19_"
        cx={16.5}
        cy={17.5}
        r={3.5}
        fill="#4bbc91"
      />
      <path
        id="Spaces_Medium_Extract_Certified_svg__Check_1_"
        d="M18.5 16c-.2-.1-.4-.1-.6.1L16.4 18l-1.1-.8c-.2-.1-.4-.1-.5 0-.1.2-.1.5 0 .6l1.2.9c.5.4.6.3.9-.1l1.7-2.2c0-.1 0-.2-.1-.4z"
        fill="#fff"
      />
      <path
        id="Spaces_Medium_Extract_Certified_svg__Arrow_5_"
        className="Spaces_Medium_Extract_Certified_svg__st0"
        d="M13.5 14.4l-2.2-1.8s-.2-.1-.2.1V14h-1c-1.4 0-2-.6-2-2v-1H7v1c0 2 1 3 3 3h1v1.4c0 .1.1.1.2.1l2.2-1.8c.2-.1.2-.2.1-.3z"
      />
    </svg>
  );
}
